var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13922_356637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.54097 4.4641L2.3038 4.6191C0.996789 5.47328 0.208984 6.92926 0.208984 8.49064V17.9703C0.208984 22.1895 2.36574 26.1159 5.9265 28.3791L11.5658 31.9635C15.7922 34.6497 21.2233 34.5138 25.3099 31.6194L35.0162 24.745C36.1893 23.9864 36.8977 22.6848 36.8977 21.2878V10.9718C36.8977 7.86666 35.3154 4.9756 32.7 3.30194C29.7465 1.41196 25.9702 1.38575 22.9908 3.23456L18.5534 5.98813L15.6973 4.25096C11.637 1.78136 6.51908 1.86427 2.54097 4.4641Z",
    fill: "url(#paint0_linear_13922_356637)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12631 13.6458L18.6945 6.98948C19.3856 6.59182 20.1137 6.26211 20.8684 6.00499L24.2006 4.86984C26.9426 3.93575 29.9259 3.99659 32.6275 5.04172L36.8977 6.69364V17.0355C36.8977 17.33 36.7855 17.6135 36.584 17.8283C36.4052 18.0189 36.1672 18.1434 35.9086 18.1817L34.0025 18.4638C32.7197 18.6537 31.4094 18.4667 30.2309 17.9256L22.5297 14.3897C20.3173 13.3739 17.7648 13.4101 15.5821 14.4883L14.9539 14.7986C13.9952 15.2721 12.922 15.4643 11.8586 15.3527L7.38855 14.8835C7.05002 14.848 6.79297 14.5626 6.79297 14.2222C6.79297 13.9843 6.92008 13.7645 7.12631 13.6458Z",
    fill: "url(#paint1_linear_13922_356637)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.332318 6.23047C0.253032 6.42351 0.208984 6.63586 0.208984 6.8643V8.64995C0.208984 7.83273 0.250096 7.02516 0.332318 6.23047ZM34.851 24.4345L34.1227 23.9744C30.5284 27.935 25.5511 30.3899 20.051 30.3899C9.09192 30.3899 0.208984 20.6573 0.208984 8.64995V24.8656C0.208984 25.4126 0.455651 25.8855 0.890254 26.159L17.8721 36.9019C18.3067 37.1753 18.803 37.1753 19.2346 36.9019L34.851 27.0212C35.2856 26.7478 35.5322 26.2748 35.5322 25.7279C35.5322 25.1809 35.2856 24.7079 34.851 24.4345Z",
    fill: "url(#paint2_linear_13922_356637)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8408 29.5545L34.5291 27.2219C33.883 27.4697 32.8876 27.2573 32.3531 26.9163L21.5967 20.1147C21.1445 19.8284 20.563 20.0021 20.3017 20.4976C20.0403 20.9931 20.1989 21.6269 20.6511 21.9132L30.7439 28.2965C30.8673 28.3738 30.97 28.4896 31.0346 28.6312C31.1903 28.9722 31.0611 29.3036 30.8408 29.5545ZM26.254 32.4566L29.9423 30.124C29.2962 30.3718 28.3007 30.1594 27.7663 29.8184L17.0099 23.0168C16.5577 22.7305 15.9762 22.9042 15.7149 23.3997C15.4535 23.8952 15.6121 24.529 16.0643 24.8153L26.1571 31.1986C26.2804 31.2758 26.3832 31.3917 26.4478 31.5332C26.6034 31.8743 26.4742 32.2057 26.254 32.4566ZM21.6672 35.3587L25.3554 33.0261C24.7094 33.2738 23.7169 33.0615 23.1795 32.7205L12.423 25.9189C11.9708 25.6325 11.3894 25.8063 11.128 26.3018C10.8667 26.7972 11.0253 27.4311 11.4775 27.7174L21.5703 34.1007C21.6936 34.1779 21.7964 34.2938 21.861 34.4353C22.0166 34.7764 21.8874 35.1078 21.6672 35.3587Z",
    fill: "#FF7A00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8983 8.84217V6.63182C36.8983 6.08486 36.6486 5.61191 36.217 5.33843L28.4059 0.396515C27.9742 0.123037 27.4779 0.123037 27.0433 0.396515L6.84016 13.176C6.3615 13.4784 6.13539 14.0157 6.15888 14.5402L24.1714 5.33843C26.0244 4.39251 27.7275 3.85521 30.2118 5.20651L36.8983 8.83895V8.84217Z",
    fill: "url(#paint3_linear_13922_356637)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2356 14.5507L31.5366 22.3336L34.8519 24.4314C35.0869 24.5794 35.266 24.7853 35.3805 25.0266L36.2145 24.4989C36.6491 24.2254 36.8958 23.7557 36.8958 23.2055V10.9473C34.5025 16.6163 27.6369 16.0919 22.6508 13.1512L20.8242 12.0734C19.6085 11.3559 18.2548 11.3044 17.136 12.0122L15.75 12.8874C12.787 14.7631 8.40282 15.4066 6.2621 13.8847C6.00956 14.5411 6.20044 15.3615 6.83766 15.7637L7.60115 16.2463C10.0796 17.81 12.8135 17.7456 15.3682 16.1305L17.8672 14.5507C18.3018 14.2773 18.7951 14.2773 19.2297 14.5507",
    fill: "url(#paint4_linear_13922_356637)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2354 14.5508L31.5364 22.3337L34.8517 24.4314C35.0866 24.5794 35.2657 24.7853 35.3803 25.0266L36.2142 24.499C36.5196 24.3059 36.734 24.0163 36.8338 23.6689C36.7164 23.3632 36.4961 23.1187 36.1907 22.9643L19.2354 14.5508Z",
    fill: "#F6B959"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.208984 8.84217V6.63182C0.208984 6.08486 0.455651 5.61191 0.890254 5.33843L8.70137 0.396515C9.13303 0.123037 9.6293 0.123037 10.0639 0.396515L18.5533 5.76634L16.4156 7.11764L12.9358 5.33843C11.0829 4.39251 9.3797 3.85521 6.89541 5.20651L0.208984 8.83895V8.84217Z",
    fill: "url(#paint5_linear_13922_356637)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13922_356637",
    x1: 18.5534,
    y1: 0.208984,
    x2: 18.5534,
    y2: 36.4047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E35224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13922_356637",
    x1: 21.8453,
    y1: 3.42383,
    x2: 21.8453,
    y2: 18.7548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AB3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13922_356637",
    x1: 17.8706,
    y1: 6.23047,
    x2: 17.8706,
    y2: 37.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E35224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13922_356637",
    x1: 21.5277,
    y1: 0.191406,
    x2: 21.5277,
    y2: 14.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AB3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_13922_356637",
    x1: 21.525,
    y1: 10.9473,
    x2: 21.525,
    y2: 25.0266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAE9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AB3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_13922_356637",
    x1: 9.38117,
    y1: 0.191406,
    x2: 9.38117,
    y2: 8.84217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E35224"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13922_356637"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.8a2355815106716eedfdbb4d0fc0e1f2.svg";
export { ForwardRef as ReactComponent };